import { render, staticRenderFns } from "./CarouselPromoCard.vue?vue&type=template&id=659cc936&"
import script from "./CarouselPromoCard.ts?vue&type=script&lang=ts&"
export * from "./CarouselPromoCard.ts?vue&type=script&lang=ts&"
import style0 from "./СarouselPromoCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports